/**
 * Google Tag Manager is an interface to Google Analytics and Google Ads
 * It needs to load on every page. The tracking codes are defined on the
 * Google Tag Manager site. Ask help desk for access if you need to add or change any.
 */
const googleTagId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID

class GoogleTagManager {
  static _track(eventName, conversionLabel, details = {}) {
    const send_to = `${googleTagId}/${conversionLabel}`
    // gtag is a global set up in Google.jsx
    // eslint-disable-next-line no-undef
    gtag('event', eventName, {
      ...details,
      send_to,
    })
  }

  trackSignup(method) {
    GoogleTagManager._track('web-sign-up', 'diUyCOX1sdABEMjLu_sC', {
      label: `Web Sign-up ${method}`,
    })
  }

  trackAddToCart() {
    GoogleTagManager._track('add-to-cart', '4f0JCMrCu_IBEMjLu_sC', {
      currency: 'USD',
      transaction_id: '',
    })
  }

  trackFirstPurchase({ total, currency = 'USD' }) {
    GoogleTagManager._track('first-purchase', 'lBCQCN-4gZcBEMjLu_sC', {
      value: total,
      currency: currency,
    })
  }

  trackPurchase({ total, currency = 'USD' }) {
    GoogleTagManager._track('purchase', 'oF89CNnEjvIBEMjLu_sC', {
      value: total,
      currency: currency,
    })
  }

  trackEnterLocation() {
    GoogleTagManager._track('enter-location', 'CjolCNSyjfIBEMjLu_sC')
  }

  trackCheckoutPageView() {
    GoogleTagManager._track('checkout-page-view', 'O4kCCNjQ_vEBEMjLu_sC')
  }
}

export const googleTagManager = new GoogleTagManager()
